import { gql } from "@apollo/client";

export const logoutQuery = gql`
query($deviceId: String!){
  logout(deviceId: $deviceId) {
    isLogin
  }
}
`;